// src/pages/KarigarManagement/Job/components/JobTypeSelection.jsx

import React from "react";
import { Card, CardContent } from "@/components/ui-v2/card";
import { CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { JOB_TYPES } from "../constants/jobConstants";

/**
 * Step 1: Job Type Selection
 */
const JobTypeSelection = ({ value, onChange, disabled = false }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-xl font-semibold">What type of job is this?</h2>
        <p className="text-muted-foreground">
          Select the type of work to be done
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {JOB_TYPES.map((type) => {
          const Icon = type.icon;
          const isSelected = value === type.value;
          return (
            <Card
              key={type.value}
              className={cn(
                "cursor-pointer transition-all hover:shadow-md",
                isSelected
                  ? "ring-2 ring-primary border-primary bg-primary/5"
                  : "hover:border-primary/50",
                disabled && "opacity-60 cursor-not-allowed"
              )}
              onClick={() => !disabled && onChange(type.value)}
            >
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div
                    className={cn(
                      "h-12 w-12 rounded-lg flex items-center justify-center",
                      type.color
                    )}
                  >
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-semibold">{type.label}</h3>
                      {isSelected && (
                        <CheckCircle className="h-4 w-4 text-primary" />
                      )}
                    </div>
                    <p className="text-sm text-muted-foreground mt-1">
                      {type.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default JobTypeSelection;
